import { Component } from '@angular/core';

@Component({
  selector: 'app-quickrepliesmanagement',
  templateUrl: './quickrepliesmanagement.component.html',
  styleUrl: './quickrepliesmanagement.component.scss'
})
export class QuickrepliesmanagementComponent {

}
